import React from 'react';

import { IconTypes } from '@eika/icon';

import { SitecoreLinks } from '@/default-config';
import { GetPathType } from '@/domain/app';
import { PiwikTag } from '@/piwik/types';

import { CreditCardPanelItemWithClick } from '@domain/card/components/CreditCardPanelItem/CreditCardPanelItemWithClick';
import { CreditCardPanelItemWithSitecoreLink } from '@domain/card/components/CreditCardPanelItem/CreditCardPanelItemWithSitecoreLink';
import { CreditCardPanelItemWithUrl } from '@domain/card/components/CreditCardPanelItem/CreditCardPanelItemWithUrl';
import { CreditCard, CreditCardAccount } from '@generated-types';

type BaseCardControlProps = {
    hide: boolean;
    iconType: IconTypes;
    piwikTag: PiwikTag;
    title: string;
    subtitle?: string;
    id?: string;
};

export type ClickCardControlProps = BaseCardControlProps & {
    onClick?: () => void;

    url?: undefined;
    sitecorePath?: undefined;
    account?: undefined;
    card?: undefined;
};

export type UrlCardControlProps = BaseCardControlProps & {
    url: string;

    onClick?: undefined;
    sitecorePath?: undefined;
    account?: undefined;
    card?: undefined;
};

export type SitecoreCardControlProps<T extends string> = BaseCardControlProps & {
    sitecorePath: GetPathType<SitecoreLinks, T>;
    account: CreditCardAccount;
    card: CreditCard;

    onClick?: undefined;
    url?: undefined;
};
type CardControlProps<T extends string> = ClickCardControlProps | UrlCardControlProps | SitecoreCardControlProps<T>;

export const CreditCardPanelItem = <T extends string>(props: CardControlProps<T>) => {
    if (props.onClick) {
        return <CreditCardPanelItemWithClick {...props} />;
    }
    if (props.url) {
        return <CreditCardPanelItemWithUrl {...props} />;
    }
    if (props.sitecorePath && props.card && props.account) {
        return <CreditCardPanelItemWithSitecoreLink {...props} />;
    }
    return undefined;
};
